import { API_BASE_URL } from "../../../config";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const EditUser = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const user = location.state?.user; // Get user data from navigation state
    const [idType, setIdType] = useState(user?.idtype || '');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).token : null;
        if (!token) return;

        try {
            const response = await fetch(`${API_BASE_URL}/api/auth/user/${user.username}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ idType }),
            });

            if (response.ok) {
                navigate('/user-management');
            } else {
                setError('Failed to update user');
            }
        } catch (error) {
            setError('Error updating user');
        }
    };

    if (!user) {
        return <p>No user data available</p>;
    }

    return (
        <div>
            <h1>Edit User</h1>
            <button onClick={() => navigate('/user-management')} className="backButton">
                กลับ
            </button>
            {error && <p className="error">{error}</p>}
            <form onSubmit={handleSubmit}>
                <div>
                    <label>
                        Username:
                        <input
                            type="text"
                            value={user.username}
                            readOnly
                        />
                    </label>
                </div>
                <div>
                    <label>
                        ID Type:
                        <input
                            type="text"
                            value={idType}
                            onChange={(e) => setIdType(e.target.value)}
                        />
                    </label>
                </div>
                <button type="submit">Save</button>
            </form>
        </div>
    );
};

export default EditUser;
